module.exports = __webpack_public_path__ + "fonts/fb87f577cddc4fcce562196d62d86a7c-Roboto-BoldItalic.woff2";